import { render, staticRenderFns } from "./ghConfirmDialog.vue?vue&type=template&id=7373f1d6&scoped=true&"
import script from "./ghConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./ghConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7373f1d6",
  null
  
)

export default component.exports